/** Sufixo fixo do `<title>` do documento (após ` | `). */
export const APP_DOCUMENT_TITLE_SUFFIX = 'Meu Mundo';
